
    import QRCode from 'qrcode'

    const screenStart    = document.getElementById('screen-start')
    const screenPairing  = document.getElementById('screen-pairing')
    const screenTutorial = document.getElementById('screen-tutorial')
    const btnCreateRoom  = document.getElementById('btn-create-room')
    const btnStartGame   = document.getElementById('btn-start-game')
    const btnHowToPlay   = document.getElementById('btn-how-to-play')
    const btnBack        = document.getElementById('btn-back')
    const btnTutPrev     = document.getElementById('btn-tut-prev')
    const btnTutNext     = document.getElementById('btn-tut-next')
    const tutorialVideo  = document.getElementById('tutorial-video')
    const tutorialLabel  = document.getElementById('tutorial-label')

    const TUTORIALS = [
      { src: '/Animations/ServeTutorial.webm',       label: 'Serve'     },
      { src: '/Animations/HitRightTutorial.webm',    label: 'Forehand'  },
      { src: '/Animations/HitBackhandTutorial.webm', label: 'Backhand'  },
    ]
    let tutIndex = 0

    function showTutorial(index) {
      tutIndex = (index + TUTORIALS.length) % TUTORIALS.length
      tutorialVideo.src = TUTORIALS[tutIndex].src
      tutorialVideo.play()
    }
    const pairingRoomId = document.getElementById('pairing-room-id')
    const qrP1          = document.getElementById('qr-p1')
    const qrP2          = document.getElementById('qr-p2')

    let ws = null
    let connectedPlayers = new Set()

    function showScreen(el) {
      document.querySelectorAll('.flow-screen').forEach(s => s.classList.remove('active'))
      if (el) el.classList.add('active')
    }

    function playConnectAnimation(role) {
      const qrEl = role === 'player1' ? qrP1 : qrP2
      const slot = qrEl.closest('.qr-slot')
      const vid = document.createElement('video')
      vid.src = '/Animations/UIMotionTransparrent.webm'
      vid.autoplay = true
      vid.muted = true
      vid.playsInline = true
      vid.className = 'qr-connect-anim'
      qrEl.style.visibility = 'hidden'
      slot.appendChild(vid)
    }

    function markPlayerConnected(role) {
      const isNew = !connectedPlayers.has(role)
      connectedPlayers.add(role)
      if (isNew) {
        const snd = connectedPlayers.size === 1
          ? new Audio('/sounds/Confirmation1.mp3')
          : new Audio('/sounds/Confirmation2.mp3')
        snd.play()
        playConnectAnimation(role)
      }
      if (connectedPlayers.size >= 1) btnStartGame.disabled = false
    }

    btnHowToPlay.addEventListener('click', () => { showTutorial(0); showScreen(screenTutorial) })
    btnBack.addEventListener('click',      () => showScreen(screenStart))
    btnTutPrev.addEventListener('click',   () => showTutorial(tutIndex - 1))
    btnTutNext.addEventListener('click',   () => showTutorial(tutIndex + 1))

    btnCreateRoom.addEventListener('click', () => {
      setTimeout(() => showScreen(screenPairing), 250)

      ws = new WebSocket(`wss://${window.location.host}/ws`)

      ws.addEventListener('open', () => {
        ws.send(JSON.stringify({ action: 'join', role: 'desktop' }))
      })

      ws.addEventListener('message', (event) => {
        const data = JSON.parse(event.data)

        if (data.action === 'joined') {
          const roomId  = data.roomId
          sessionStorage.setItem('roomId', roomId)
          pairingRoomId.textContent = roomId
          const base = `${window.location.protocol}//${window.location.host}/phone.html?roomid=${roomId}`
          for (const [container, role] of [[qrP1, 'player1'], [qrP2, 'player2']]) {
            const canvas = document.createElement('canvas')
            container.innerHTML = ''
            container.appendChild(canvas)
            QRCode.toCanvas(canvas, `${base}&role=${role}`, { width: window.innerWidth * 0.22, color: { dark: '#000000', light: '#00000000' } })
          }
          return
        }

        if (data.action === 'player_joined') {
          markPlayerConnected(data.role)
          return
        }
      })
    })

    btnStartGame.addEventListener('click', () => {
      if (ws) ws.close()
      window.location.href = '/game.html'
    })
  